import type { WorkOption } from '../types';

export interface Step3Content {
  title: string;
  subtitle: string;
}

export const step3ContentMap: Record<WorkOption, Step3Content> = {
  'ux-discovery': {
    title: 'Tell us more about the UX problem',
    subtitle: 'Tell us more about the UX problem to understand the context',
  },
  'explore-problem': {
    title: 'Describe the problem you want to explore',
    subtitle: 'Share details about the UX problem to help us explore and generate solutions',
  },
  'generate-solutions': {
    title: 'Describe the prototype you want to generate...',
    subtitle: 'Share details about the solution you want to prototype',
  },
  'not-sure': {
    title: 'What would you like to explore?',
    subtitle: 'Start by describing what you want to explore and we\'ll help you discover possibilities',
  },
};

